import { nextTick } from 'vue';
import { mapState } from 'vuex';
import { consoleLogErrorIfNotProd } from '@/elements/utils.js';
import { getFilterItemsIds } from '@/elements/utils.js';
import { getFilteredList } from '@/utils/filters.js';
import EventBus from '@/elements/eventBus.js';

const TIMER_DELAY = 500;

export default {
  data() {
    return {
      filterStates: {},
      filterTimer: null,
      filterText: '',
    };
  },
  created() {
    if (this.filters) {
      this.fillFilterStates();
    }
  },
  computed: {
    ...mapState({
      profileId: (state) => state.profile.id,
    }),
    collection() {
      const { filters, filterStates, fullCollection: collection } = this;
      return this.filters ? this.handleListLoading({ filters, filterStates, collection }) : collection;
    },
    isFilterActive() {
      return Object.values(this.filterStates).some(Boolean);
    },
  },
  watch: {
    filters(newVal) {
      if (newVal) {
        this.fillFilterStates();
      }
    },
  },
  methods: {
    handleListLoading(payload) {
      EventBus.$emit('setTableSpinner', true);
      const list = getFilteredList(payload);
      EventBus.$emit('setTableSpinner', false);
      return list;
    },
    fillFilterStates() {
      const text = this.filters.text.id;
      const main = getFilterItemsIds(this.filters.main);
      const intersection = getFilterItemsIds(this.filters.intersection);
      const checked = [].concat(main, intersection);
      let savedStates = {};
      try {
        savedStates =
          JSON.parse(window.localStorage.getItem(`user:${this.profileId}:filterStates:${this.tableId}`)) || {};
      } catch (error) {
        consoleLogErrorIfNotProd(error);
      } finally {
        if (text) {
          this.filterStates[text] = savedStates[this.filters.text.id] || '';
        }
        if (checked.length > 0) {
          checked.forEach((item) => {
            this.filterStates[item] = savedStates[item] || false;
          });
        }
      }
    },
    onClearFilters() {
      for (const filter in this.filterStates) {
        if (filter === 'textFilter') {
          this.filterStates[filter] = '';
        } else {
          this.filterStates[filter] = false;
        }
      }
      this.applyFilterChange();
    },
    onChangeFilter({ prop, value }) {
      this.setFilterTimer(value, prop);
    },
    onChangeTextFilter(text) {
      this.filterText = text;
      let delay = TIMER_DELAY;
      if (text === '') {
        delay = 0;
      }
      this.setFilterTimer(text, 'textFilter', delay);
    },
    onEnter() {
      this.setFilterTimer(this.filterText, 'textFilter', 0);
    },
    setFilterTimer(value, prop, delay = TIMER_DELAY) {
      clearTimeout(this.filterTimer);
      this.filterTimer = setTimeout(() => {
        this.setTextFilter(value, prop);
      }, delay);
    },
    setTextFilter(value, prop) {
      this.filterStates[prop] = value;
      this.applyFilterChange();
    },
    async applyFilterChange() {
      await nextTick();
      // update actions if filters applied from component
      this.emitTableChange?.();
      // update actions if filters applied from table
      this.triggerChange?.();
      try {
        window.localStorage.setItem(
          `user:${this.profileId}:filterStates:${this.tableId}`,
          JSON.stringify(this.filterStates)
        );
      } catch (error) {
        consoleLogErrorIfNotProd(error);
      }
    },
  },
};
